import React from 'react';
interface ButtonProps {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg' | 'full';
  onClick?: (e?: React.MouseEvent) => void;
  type?: 'button' | 'submit' | 'reset';
  disabled?: boolean;
  className?: string;
  href?: string;
}
export function Button({
  children,
  variant = 'primary',
  size = 'md',
  className = '',
  href,
  onClick,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-bold rounded-full transition-all focus:outline-none hover:ring-2 hover:ring-offset-2 focus:ring-2 focus:ring-offset-2 focus:ring-[#FFFC00]';
  const variantStyles = {
    primary: 'bg-[#FFFC00] text-[#1A1A1A] hover:bg-[#e6e300] hover:ring-[#FFFC00] focus:ring-[#FFFC00] shadow-sm',
    secondary: 'bg-white text-[#1A1A1A] border-2 border-[#1A1A1A] hover:bg-gray-50 hover:ring-[#1A1A1A] focus:ring-[#1A1A1A]',
    outline: 'bg-transparent border-2 border-[#1A1A1A] text-[#1A1A1A] hover:bg-[#FFFC00] hover:border-[#FFFC00] hover:ring-[#FFFC00] focus:ring-[#FFFC00]'
  };
  const sizeStyles = {
    sm: 'py-1.5 px-4 text-sm',
    md: 'py-2.5 px-6 text-base',
    lg: 'py-3 px-8 text-lg',
    full: 'py-3 px-8 text-lg w-full'
  };
  const styles = `${baseStyles} ${variantStyles[variant]} ${sizeStyles[size]} ${className}`;
  // If href is provided, render an anchor tag
  if (href) {
    return <a href={href} className={styles} onClick={onClick} target="_blank" rel="noopener noreferrer" data-id="element-117">
        {children}
      </a>;
  }
  // Otherwise render a button
  return <button className={styles} onClick={onClick} {...props} data-id="element-118">
      {children}
    </button>;
}